import { Key, ReactElement } from "react"

import { Box, Stack } from "@/generated/material"

interface ListProps<T> {
  data: T[]
  keyField: keyof T
  children: (data: T, index: number) => ReactElement
}

export function List<T>({ data, keyField, children }: ListProps<T>) {
  return (
    <Stack gap="xl" paddingTop="lg">
      {data.map((item, index) => {
        return <Box key={item[keyField] as Key}>{children(item, index)}</Box>
      })}
    </Stack>
  )
}
